import React, { lazy } from 'react';
import { GiftIcon } from 'lucide-react';
import { CONSTANTS } from '../utils/constants';
import { scrollToOffer } from '../utils/scroll';
export function BonusSection() {
  const bonuses = [{
    num: 1,
    title: 'Ricettario Speciale di Plumcake Salati',
    desc: 'Impara a preparare plumcake salati perfetti per aperitivi, pranzi veloci o cene leggere.',
    value: '9,99',
    img: CONSTANTS.IMAGES.BONUS_1
  }, {
    num: 2,
    title: 'Guida a Glasse e Coperture per Plumcake',
    desc: 'Trasforma qualsiasi plumcake semplice in una ricetta spettacolare.',
    value: '12,99',
    img: CONSTANTS.IMAGES.BONUS_2
  }, {
    num: 3,
    title: 'Kit per Iniziare a Vendere Plumcake',
    desc: 'Scopri come calcolare i prezzi, presentare i prodotti e vendere da casa.',
    value: '14,99',
    img: CONSTANTS.IMAGES.BONUS_3
  }, {
    num: 4,
    title: 'Tabella di Conversioni e Trucchi di Pasticceria',
    desc: 'Conversioni, proporzioni e segreti professionali.',
    value: '9,99',
    img: CONSTANTS.IMAGES.BONUS_4
  }];
  return <section className="py-20 px-4 bg-blue-900 text-white" data-id="element-28">
      <div className="max-w-5xl mx-auto" data-id="element-29">
        <div className="text-center mb-12" data-id="element-30">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-yellow-400" data-id="element-31">
            🎁 BONUS GRATUITI (Solo per oggi)
          </h2>
          <p className="text-xl text-blue-100" data-id="element-32">
            Per aiutarti ancora di più, riceverai anche 4 bonus esclusivi
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-33">
          {bonuses.map(bonus => <div key={bonus.num} onClick={scrollToOffer} className="bg-white rounded-2xl overflow-hidden flex flex-col sm:flex-row cursor-pointer transform transition-transform hover:-translate-y-1 hover:shadow-2xl" data-id="element-34">
              {/* Left Image Side */}
              <div className="w-full sm:w-2/5 bg-gray-50 relative p-4 flex items-center justify-center" data-id="element-35">
                <div className="absolute top-0 left-0 w-full bg-red-600 text-white text-xs font-bold text-center py-1 uppercase tracking-wider z-10" data-id="element-36">
                  GRATIS per oggi
                </div>
                <img src={bonus.img} alt={bonus.title} className="w-full max-w-[150px] object-contain drop-shadow-lg mt-4" loading="lazy" data-id="element-37" />
              </div>

              {/* Right Content Side */}
              <div className="w-full sm:w-3/5 p-6 flex flex-col justify-center" data-id="element-38">
                <div className="flex items-center gap-2 text-orange-500 font-bold mb-2" data-id="element-39">
                  <GiftIcon className="w-5 h-5" data-id="element-40" />
                  <span data-id="element-41">BONUS {bonus.num}</span>
                </div>
                <h3 className="text-gray-900 font-bold text-lg mb-2 leading-tight" data-id="element-42">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 text-sm mb-4 flex-grow" data-id="element-43">
                  {bonus.desc}
                </p>
                <div className="flex items-center gap-2 mt-auto" data-id="element-44">
                  <span className="text-gray-400 line-through text-sm" data-id="element-45">
                    Valore: {bonus.value} €
                  </span>
                  <span className="text-green-600 font-bold" data-id="element-46">GRATIS</span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-blue-800/50 border border-blue-700 rounded-2xl p-6 text-center mb-10 max-w-2xl mx-auto" data-id="element-47">
          <p className="text-xl font-medium" data-id="element-48">
            In totale riceverai{' '}
            <span className="font-bold text-yellow-400 text-2xl" data-id="element-49">9</span>{' '}
            risorse complete
          </p>
        </div>

        <div className="text-center" data-id="element-50">
          <button onClick={scrollToOffer} className="bg-orange-500 hover:bg-orange-600 text-white rounded-full py-5 px-10 font-bold text-xl md:text-2xl shadow-[0_0_30px_rgba(249,115,22,0.4)] transition-all transform hover:scale-105 w-full md:w-auto" data-id="element-51">
            VOGLIO TUTTI I BONUS ORA
          </button>
        </div>
      </div>
    </section>;
}